import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import AppLayout from "./layout/AppLayout";
import PublicLayout from "./layout/PublicLayout";
import RequireRole from "./auth/RequireRole";

import EtfDashboard from "./pages/AdminHome";
import Masters from "./pages/Masters";
import AdminDailyData from "./pages/AdminDailyData";
import AdminIndividualData from "./pages/AdminIndividualData";
import FreeHome from "./pages/FreeHome";
import UserHome from "./pages/UserHome";
import Rankings from "./pages/Rankings";
import AuthLogin from "./pages/AuthLogin";
import AuthRegister from "./pages/AuthRegister";

const App = () => {
  return (
    <Switch>
      <Route path="/admin">
        <RequireRole allowed={["admin"]}>
          <AppLayout>
            <Switch>
              <Route exact path="/admin" component={EtfDashboard} />
              <Route exact path="/admin/masters" component={Masters} />
              <Route exact path="/admin/daily-data" component={AdminDailyData} />
              <Route exact path="/admin/individual-data" component={AdminIndividualData} />
              <Redirect to="/admin" />
            </Switch>
          </AppLayout>
        </RequireRole>
      </Route>

      <Route exact path="/login">
        <PublicLayout>
          <AuthLogin />
        </PublicLayout>
      </Route>

      <Route exact path="/register">
        <PublicLayout>
          <AuthRegister />
        </PublicLayout>
      </Route>

      <Route exact path="/market-data">
        <PublicLayout>
          <UserHome />
        </PublicLayout>
      </Route>

      <Route exact path="/rankings">
        <PublicLayout>
          <Rankings />
        </PublicLayout>
      </Route>

      <Route exact path="/home">
        <Redirect to="/market-data" />
      </Route>

      <Route exact path="/">
        <PublicLayout>
          <FreeHome />
        </PublicLayout>
      </Route>

      <Redirect to="/" />
    </Switch>
  );
};

export default App;
